import { ExternalInjectionService } from './external-injection.service';

export default angular
  .module('sfMobile.services.external-injection', [])
  .service('externalInjectionService', ExternalInjectionService).name;
